import { useState } from 'react';

import {
  Table,
  TableBody,
  TableHead,
  TableHeader,
  TableRow,
} from '@/shared/components/shadcn/table';

import { useScrapingIntentRuns } from '../../model/use-scraping-intent-runs';
import {
  ScrapingEmptyState,
  ScrapingErrorState,
  ScrapingTableLoadingState,
} from '../../ui/scraping-section-state';
import { ScrapingPagination } from '../../ui/scraping-pagination';
import { ScrapingRunRow } from '../scraping-run/scraping-run-row';

type ScrapingIntentRunListProps = {
  intentId: string;
};

export function ScrapingIntentRunList({ intentId }: ScrapingIntentRunListProps) {
  const [cursorStack, setCursorStack] = useState<string[]>([]);
  const cursor = cursorStack.at(-1);
  const runsQuery = useScrapingIntentRuns({ intentId, limit: 20, cursor });

  if (runsQuery.isPending) {
    return <ScrapingTableLoadingState />;
  }

  if (runsQuery.isError) {
    return <ScrapingErrorState onRetry={() => void runsQuery.refetch()} />;
  }

  if (runsQuery.data.items.length === 0) {
    return <ScrapingEmptyState />;
  }

  return (
    <div className="flex flex-col gap-3">
      <Table>
        <TableHeader>
          <TableRow gridTemplateColumns="minmax(140px,1fr) minmax(150px,1fr) minmax(150px,1fr) minmax(220px,1.5fr)">
            <TableHead>Execution date</TableHead>
            <TableHead>Status</TableHead>
            <TableHead>Created</TableHead>
            <TableHead>Actions</TableHead>
          </TableRow>
        </TableHeader>
        <TableBody>
          {runsQuery.data.items.map((run) => (
            <ScrapingRunRow key={run.run_id} run={run} intent_id={intentId} />
          ))}
        </TableBody>
      </Table>
      <ScrapingPagination
        hasMore={runsQuery.data.page.has_more}
        canGoBack={cursorStack.length > 0}
        isFetching={runsQuery.isFetching}
        onNext={() => {
          const nextCursor = runsQuery.data.page.next_cursor;

          if (nextCursor != null) {
            setCursorStack((previous) => [...previous, nextCursor]);
          }
        }}
        onBack={() => setCursorStack((previous) => previous.slice(0, -1))}
      />
    </div>
  );
}
